import { useSelector } from "react-redux" // hook to access redux state
import Loader from "./Loader" // import loader component

export default function GlobalLoader() {

  const { loading } = useSelector(state => state.loader) // get loading state from redux

  if (!loading) return null // if not loading, render nothing

  return (

    <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-[99999]">
      <Loader /> {/* loader component in center */}

    </div>

  )

}